enum CELL_PLACEMENT_STATUS {
  ZERO_PLACED = 'ZERO_PLACED', //zero tires placed in the cell
  UNDERLOADED = 'UNDERLOADED', //less than the full TR order placed in the cell
  OVERLOADED = 'OVERLOADED', //more than the full TR order placed in the cell
  ALL_PLACED = 'ALL_PLACED', //exactly the full TR order placed in the cell
}

export { CELL_PLACEMENT_STATUS }